/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GroupRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+UlEQVR4nOWVO2sWQRSGV+xsBA2CBqz8BUKif0Gz57LFfOddjIWFith4ay0NIX3+SLRSRKMmxsbO0lsRgiiJtxAtzMqZ7H7Jd80mbueBZZnh7HnmvO/MbJL8d0FZ6yypLbFincUWfdxY8Sy7cJzU1lhRbD/2zecbA7BgpROAgtSuJU1FmoaTLPa2EYBqPk6KBVb76W8fR0jWGmPFZll8bV8SRTnUVrv0Xq2KsdjDCGec2dfqRfKr3VqXK76SNBFeqB+AFZdjBwwmtWUSe0CKPIRwsGmJnnZ19poonNoTxE1lwQsS/PC3m9vuUOxTH/mWkqaCFJOkeMOK6TRrnc6yyWNJkhyo9bHrSWrCgvss9oEVv0jxntTmXPs96917kPBygMFFfDJcb+dLrqSYZ7ENv59I8UQkp7iFxZ73FO+nLXca/TmEcCTKJJgZnouiUxaxV7t9QGJ3q5VvjfGbBDccqnrxKKvd8rkeQNR8l+KsKNzQ0uT5OMe4ucP4hYEdRANrAEIIhz0//g8cmOYjVQ3XvHPb4lkbwIp3pcazQztI00M7AS5Lrd0Td4DYn4mJMDoMoOWNWp1kEtyuC7hXtURiXwYANkXy8zGfwZXJbmy8WhgnUrE7rPjo91Mt8NBFiU0N7JZbl/4Z4OGHisUek+I7Cb6S4lGqdq5K+Av9wb2J5qMTvwAAAABJRU5ErkJggg==)
 */
export const GroupRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.5 8a3 3 0 1 0-2.7-4.3c-.2.4.06.86.44 1.12a5 5 0 0 1 2.14 3.08c.01.06.06.1.12.1ZM12.38 21.27c.11.35-.13.73-.5.73H5.5a.5.5 0 0 1-.5-.5v-2.1c0-.25-.31-.33-.42-.1-.32.67-.67 1.58-.88 2.54a.2.2 0 0 1-.2.16A1.5 1.5 0 0 1 2 20.5a7.5 7.5 0 0 1 11.3-6.47c.26.16.3.5.12.74a6.97 6.97 0 0 0-1.04 6.5ZM20.12 14.14v-.01c.3.07.59.16.86.28M15.08 12.81c.17.12.4.14.58.04a6.97 6.97 0 0 1 3.67-.84c.46.02.79-.5.46-.83a7.48 7.48 0 0 0-4.3-2.11c-.54-.08-.98.38-1.09.92-.06.3-.15.6-.26.87-.23.58-.05 1.3.47 1.63l.47.32ZM9.5 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 19a3 3 0 0 1 5.24-2H20a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-2 0 5 5 0 1 0 .3 7.75 1 1 0 0 0-1.32-1.5A3 3 0 0 1 16 19Z"
        className={colorClass}
      />
    </svg>
  );
};
